<template>
  <div>
    <b-table :data="korpa" :checked-rows.sync="za_brisanje">
      <b-table-column
        field="index"
        label="Редни број"
        width="120"
        numeric
        v-slot="props"
      >
        {{ props.index + 1 }}
      </b-table-column>
      <b-table-column field="svrha_uplate" label="Производ" v-slot="props">
        {{ props.row.svrha_uplate }}
      </b-table-column>
      <b-table-column field="id" label="Износ" numeric v-slot="props">
        {{ props.row.iznos }} дин.
      </b-table-column>
      <b-table-column label="" centered v-slot="props">
        <a :href="'korpa/' + props.index" v-show="!izmenaZabranjena"
          ><i
            class="fas fa-trash"
            @click.prevent="obrisiStavku(props.index)"
          ></i
        ></a>
      </b-table-column>
      <template slot="footer">
        <div class="has-text-right">
          Укупно за уплату: {{ ukupnoZaUplatu }} дин.
        </div>
      </template>
    </b-table>
    <b-field
      label="Име и презиме уплатиоца"
      :type="$v.uplatilac.$error ? 'is-danger' : ''"
      :message="
        $v.uplatilac.$error ? 'Име и презиме уплатиоца је обавезно' : ''
      "
    >
      <!-- <b-input @input="updateUplatilac"></b-input> -->
      <b-input v-model="uplatilac" :disabled="izmenaZabranjena"></b-input>
    </b-field>

    <b-field
      label="E-mail уплатиоца"
      :type="$v.email.$error ? 'is-danger' : ''"
      :message="$v.email.$error ? 'E-mail уплатиоца је обавезан' : ''"
    >
      <b-input v-model="email" :disabled="izmenaZabranjena"></b-input>
    </b-field>

    <b-button
      class="is-pulled-left"
      tag="router-link"
      :to="{
        path: '/kupovina',
        query: { step: '0' }
      }"
      >&lt;&lt;</b-button
    >
    <b-button class="is-pulled-right" @click="onDaljeClick">&gt;&gt;</b-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      za_brisanje: [],
      kolone_korpe: [
        // {
        //   field: 'redni_broj',
        //   label: 'Редни број'
        // },
        {
          field: 'svrha_uplate',
          label: 'Тип карте'
        },
        // {
        //   field: 'jedinicna_cena',
        //   label: 'Јединична цена'
        // },
        // {
        //   field: 'kolicina',
        //   label: 'Количина'
        // },
        {
          field: 'iznos',
          label: 'Износ'
        }
      ]
    }
  },
  methods: {
    mounted() {},
    obrisiStavku(index) {
      this.$store.dispatch('placanje/obrisiStavkuKorpe', index)
    },
    updateUplatilac(value) {
      console.log(value)
      this.$store.dispatch('placanje/updateUplatilac', value)
    },
    onDaljeClick() {
      console.log('onDaljeClick')

      this.$v.$touch()

      if (this.$v.$invalid) {
        console.log('ERROR')
        return
      }

      this.$router.push({
        path: '/kupovina',
        query: { step: '2' }
      })
    }
  },
  computed: {
    ...mapState('placanje', ['korpa']),
    ...mapGetters('placanje', ['ukupnoZaUplatu', 'izmenaZabranjena']),
    uplatilac: {
      get() {
        return this.$store.state.placanje.uplatilac
      },
      set(value) {
        this.$store.dispatch('placanje/updateUplatilac', value)
      }
    },
    email: {
      get() {
        return this.$store.state.placanje.email
      },
      set(value) {
        this.$store.dispatch('placanje/updateEmail', value)
      }
    }
  },
  validations: {
    uplatilac: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(100)
    },
    email: {
      required,
      email
    }
  }
}
</script>

<style></style>
